// Accordion.tsx
import React from 'react';
import { AccordionWrapper } from './AccordionStyles';
import AccordionItem from './AccordionItem';

interface AccordionProps {
  items: {
    id: number;
    title: string;
    content: React.ReactNode;
  };
}

const SingleAccordion: React.FC<AccordionProps> = (props) => {
  return (
    <AccordionWrapper>
      
        <AccordionItem key={props.items?.id} title={props.items?.title}>
          {props?.children}
        </AccordionItem>
     
    </AccordionWrapper>
  );
};

export default SingleAccordion;
